module.exports = __webpack_public_path__ + "img/accessories.b2cca71d.png";